<template>
  <SideModal
    :show="show"
    @update:show="
      {
        if (!state.loadingSave) $emit('update:show', $event);
      }
    "
    location="left"
    close-on-overlay-click
  >
    <div class="modal-container">
      <div class="modal-top">
        <Typography color="primary" weight="600" size="1.25rem">Add Student</Typography>
        <v-btn
          @click="
            {
              if (!state.loadingSave) $emit('update:show', false);
            }
          "
          variant="plain"
          color="normal"
          icon
          ><v-icon color="gray600">mdi-close</v-icon></v-btn
        >
      </div>

      <form @submit.prevent="save" class="modal-body">
        <div>
          <v-text-field
            class="custom-input"
            color="primary"
            label="First Name"
            v-model="state.child_fname"
          ></v-text-field>

          <FormValidate
            :validate="state.child_fname"
            :regex="/.{1,50}/"
            title="First Name must have length of 1 to 50 characters"
          ></FormValidate>
        </div>
        <div>
          <v-text-field
            class="custom-input"
            color="primary"
            label="Last Name"
            v-model="state.child_lname"
          ></v-text-field>
          <FormValidate
            :validate="state.child_lname"
            :regex="/.{1,50}/"
            title="Last Name must have length of 1 to 50 characters"
          ></FormValidate>
        </div>
        <div>
          <v-text-field
            class="custom-input"
            color="primary"
            label="Description"
            v-model="state.description"
          ></v-text-field>
        </div>
        <div>
          <v-text-field
            class="custom-input"
            color="primary"
            label="External ID"
            v-model="state.external_id"
          ></v-text-field>
          <FormValidate
            :validate="state.external_id"
            :regex="/.{1,50}/"
            title="External ID must have length of 1 to 50 characters"
          ></FormValidate>
        </div>
        <div>
          <v-btn
            width="100%"
            type="submit"
            :loading="state.loadingSave"
            style="text-transform: capitalize"
            >Save</v-btn
          >
        </div>
      </form>
    </div>
  </SideModal>
</template>

<script setup lang="ts">
import SideModal from "@/components/sideModal.vue";
import Typography from "@/components/typography.vue";
import { watch } from "vue";
import { reactive } from "vue";
import { useAlertsStore } from "@/stores/alerts";
import useStudents from "@/stores/school/students";
import FormValidate from "@/components/formValidate.vue";

const props = defineProps<{
  show: boolean;
}>();

const emit = defineEmits<{
  (event: "update:search", val: string): void;
  (event: "update:show", val: boolean): void;
}>();

const state = reactive({
  loadingSave: false,
  child_fname: "",
  child_lname: "",
  external_id: "",
  description: ""
});

const studentsS = useStudents();

watch([() => props.show], () => {
  Object.assign(state, {
    loadingSave: false,
    child_fname: "",
    child_lname: "",
    external_id: "",
    description: ""
  });
});

const save = async () => {
  // save student
  state.loadingSave = true;

  const res = await studentsS.createStudent({
    child_fname: state.child_fname,
    child_lname: state.child_lname,
    description: state.description,
    external_id: state.external_id
  });

  useAlertsStore().addAlert(
    res ? "success" : "error",
    res ? "Student Created successfully" : "Failed to add new student",
    7
  );
  if (res) {
    emit("update:search", state.external_id);
  }
  state.loadingSave = false;
};
</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;

.modal-container {
  padding: 30px;

  .modal-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .modal-body {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 30px;
  }
}
</style>
